﻿import { MonitorStatus } from '@fe/core';
import { getSeverityString, productsFlat } from '@fe/weather';
import { DateTimeFormatter } from '../../../formatters';
import { ImpactsTooltipData } from '../../../services/map-interaction-service';

export function ImpactsTooltip(props: { info: ImpactsTooltipData }) {
    const context = props.info;

    return (
        <div
            style={{
                maxWidth: 250,
                backgroundColor: 'var(--bg-color)'
            }}>
            {context.items.map((x, i) => (
                <div key={i} className="p-2" style={{ fontSize: 12 }}>
                    <div className="fw-bold">{x.acid ?? ''} Impact</div>

                    {import.meta.env.DEV && <code>{x.id}</code>}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridColumnGap: '0.25em' }}>
                        <div className="secondary-text-color">Impact type</div>
                        <div>{x.name}</div>
                        <div className="secondary-text-color">Monitor Status</div>
                        <div>{MonitorStatus[x.monitorStatus].charAt(0).toUpperCase() + MonitorStatus[x.monitorStatus].slice(1)}</div>
                        <div className="secondary-text-color">Severity</div>
                        <div>{getSeverityString(x.productCode, x.severity)}</div>
                        <div className="secondary-text-color">Impact Source</div>
                        <div>{x.vendor}</div>
                        <div className="secondary-text-color">Weather product</div>
                        <div>{productsFlat.find((p) => p.id === x.productCode)?.name}</div>
                        <div className="secondary-text-color">Prod valid</div>
                        <div>{DateTimeFormatter.formatTime(x.productValidTime)}</div>
                        <div className="secondary-text-color">Model valid</div>
                        <div>{DateTimeFormatter.formatTime(x.productModelTime)}</div>
                        <div className="secondary-text-color">Altitude base</div>
                        <div>{x.altitudeBase}</div>
                        <div className="secondary-text-color">Altitude top</div>
                        <div>{x.altitudeTop}</div>
                        <div className="secondary-text-color">Entry time</div>
                        <div>{x.startTime ? DateTimeFormatter.formatTime(x.startTime) : '-'}</div>
                        <div className="secondary-text-color">Exit time</div>
                        <div>{x.endTime ? DateTimeFormatter.formatTime(x.endTime) : '-'}</div>
                    </div>
                </div>
            ))}
        </div>
    );
}
